module.exports = __webpack_public_path__ + "img/IMG_2435.eff9dd49.jpg";